export default "/images/Warranty.svg?d828b75af41ce866974078a3f52bf428";